import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { logOut } from '../../../features/redux/sessionSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplications,
  getSessions,
  getLoadingStart,
  getLoadingRestart,
  setCurrentSessionId,
  startApplicationAsync,
  stopApplicationAsync,
  getLoading,
  setAppTimeoutLoading,
  restartApplicationAsync,
} from '../../../features/redux/appSlice';
import { useNavigate } from 'react-router-dom';
import Can from '../../permissions/Can';
import Confirm from '../Confirm/Confirm';

function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const applications = useSelector(getApplications);
  const sessions = useSelector(getSessions);
  const isLoading = useSelector(getLoading);
  const isLoadingStart = useSelector(getLoadingStart);
  const istLoadingRestart = useSelector(getLoadingRestart);
  const [applicationsOpen, setApplicationsOpen] = useState(false);
  const [currentApplication, setCurrentApplication] = useState(null);
  useEffect(() => {
    const currentSession = sessions.find(
      (s) => s.application_id === (currentApplication || {}).id,
    );
    if (currentSession) {
      dispatch(setAppTimeoutLoading(true));
    }
    setTimeout(() => {
      dispatch(setCurrentSessionId((currentSession || { id: null }).id));
    }, 4000);
    if (applications.length > 0 && !currentApplication) {
      setCurrentApplication(applications[0]);
    }
  }, [applications, sessions]);

  const currentSession = sessions.find(
    (s) => s.application_id === (currentApplication || {}).id,
  );
  return (
    <nav className='navbar navbar-expand-lg navbar-light bg-light'>
      <div className='collapse navbar-collapse' id='navbarSupportedContent'>
        {currentApplication && (
          <div className='btn-group btn-group-toggle' data-toggle='buttons'>
            <button
              disabled={!currentApplication || isLoading}
              className={`btn btn-outline-${currentSession ? 'warning' : 'success'} my-2 my-sm-0`}
              onClick={() => {
                if (currentSession) {
                  Confirm.confirm(
                    'Are you sure you want to stop application. your wrok will be lost',
                  )
                    .then(() => {
                      dispatch(
                        stopApplicationAsync({ session_id: currentSession.id }),
                      );
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                } else {
                  dispatch(startApplicationAsync(currentApplication));
                }
              }}
              type='submit'
            >
              {currentSession ? 'Stop' : 'Start'}
              {!isLoadingStart && (
                <i
                  style={{ marginLeft: '4px' }}
                  className={`fa fa-${currentSession ? 'stop' : 'play'}`}
                ></i>
              )}
              {isLoadingStart && (
                <i
                  style={{ marginLeft: '4px' }}
                  className='fa-solid fa-circle-notch fa-spin'
                ></i>
              )}
            </button>
            {currentSession && (
              <button
                disabled={!currentApplication || isLoading}
                className='btn btn-outline-danger my-2 my-sm-0'
                onClick={() => {
                  if (currentSession) {
                    Confirm.confirm(
                      'Are you sure you want to restart application. your work will be lost',
                    )
                      .then(() => {
                        dispatch(
                          restartApplicationAsync({
                            session_id: currentSession.id,
                          }),
                        );
                      })
                      .catch((e) => {
                        console.log(e);
                      });
                  } else {
                    dispatch(startApplicationAsync(currentApplication));
                  }
                }}
                type='submit'
              >
                Restart
                {!istLoadingRestart && (
                  <i
                    style={{ marginLeft: '4px' }}
                    className='fa-solid fa-arrow-rotate-left'
                  ></i>
                )}
                {istLoadingRestart && (
                  <i
                    style={{ marginLeft: '4px' }}
                    className='fa fa-circle-notch fa-spin'
                  ></i>
                )}
              </button>
            )}
          </div>
        )}
        <div className='dropdown'>
          <button
            disabled={isLoading}
            className='btn btn-secondary dropdown-toggle'
            type='button'
            id='dropdownMenuButton'
            onClick={() => {
              setApplicationsOpen(!applicationsOpen);
            }}
          >
            {(currentApplication || {}).name || 'Select Application'}
          </button>
          <div
            className='dropdown-menu'
            style={{ display: applicationsOpen ? 'block' : 'none' }}
          >
            {applications.map((application, index) => {
              return (
                <a
                  key={'app-' + index}
                  className='dropdown-item'
                  onClick={() => {
                    setCurrentApplication(application);

                    setApplicationsOpen(false);
                    const currentSession = sessions.find(
                      (s) => s.application_id === (application || {}).id,
                    );
                    dispatch(
                      setCurrentSessionId((currentSession || { id: null }).id),
                    );
                  }}
                  href='#'
                >
                  {application.name}
                </a>
              );
            })}
          </div>
        </div>
        <div className='btn-group btn-group-toggle' data-toggle='buttons'>
          <Can action={'admin-dashboard'}>
            <button
              className='btn btn-outline-success my-2 my-sm-0'
              onClick={() => {
                navigate('/admin-dashboard');
              }}
              type='submit'
            >
              Admin
            </button>
          </Can>
          <button
            className='btn btn-outline-danger my-2 my-sm-0'
            onClick={() => {
              dispatch(logOut());
            }}
            type='submit'
          >
            Log Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
